import Vue from "vue";
import VueI18n from "vue-i18n";

import en from "@../../../public/translations/en/frontend.json";
const loadedLanguages = ["en"];
const fallbackLocale = "en";

Vue.use(VueI18n);

// /!\ LDatePicker has its own logic for handling i18n /!\ \\

const i18n = new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || fallbackLocale,
    fallbackLocale,
    messages: { en },
});

// https://kazupon.github.io/vue-i18n/guide/lazy-loading.html
export function loadLanguageAsync(lang = fallbackLocale) {
    // If the same language
    if (i18n.locale === lang) {
        return Promise.resolve(lang);
    }

    // If the language was already loaded
    if (loadedLanguages.includes(lang)) {
        return Promise.resolve(lang);
    }

    // If the language hasn't been loaded yet
    return import(
        /* webpackChunkName: "lang-[request]" */ `@../../../public/translations/${lang}/frontend.json`
    ).then(messages => {
        i18n.setLocaleMessage(lang, messages.default);
        loadedLanguages.push(lang);
        return lang;
    });
}

export default i18n;
